<template>
    <div class="status-chooser">
        <div class="selected-status" :id="id" :class="{disabled}">
            <div class="name">{{ selectedName }}</div>
            <span class="icon far fa-chevron-down"></span>
        </div>
        <elem-dropdown :triggerSelector="`#${id}`" :closeOnClick="false">
            <template v-slot:default="slotProps">
                <selectable-list
                    :items="listItems"
                    :value="value"
                    :active="slotProps.isOpen"
                    :onSelect="onSelect"
                    :multiple="multiple"
                />
            </template>
        </elem-dropdown>
    </div>
</template>
<script>
    import { strings } from '../utils';
    import { mapGetters } from 'vuex';

    export default {
        name: 'Status',
        data() {
            return {
                id: strings.random(),
            };
        },
        props: {
            value: {
                type: [String, Array],
                default: '',
            },
            name: {
                type: String,
                default: '',
            },
            noSelectionText: {
                type: String,
                default: '',
            },
            disabled: {
                type: Boolean,
                default: false
            },
            multiple: {
                type: Boolean,
                default: false
            },
            extraItems: {
                type: Array,
                default: function() {
                    return [];
                }
            }
        },
        computed: {
            ...mapGetters({}),
            listItems() {
                return [
                    { name: 'Submitted', value: 'Active' },
                    { name: 'Pending', value: 'Pending' },
                    ...this.extraItems
                ];
            },
            selectedName() {
                if (!this.value || (this.multiple && !this.value.length)) {
                    return this.noSelectionText;
                }
                if (this.multiple) {
                    return this.listItems.reduce((acc, item) => {
                        if (this.value.includes(item.value)) {
                            acc += (acc ? ', ' : '') + item.name;
                        }
                        return acc;
                    }, '');
                }
                let item = this.listItems.find(item => item.value === this.value);
                return item ? item.name : this.noSelectionText;
            }
        },
        methods: {
            onSelect(item) {
                if (this.multiple) {
                    this.$emit('change', item);
                } else if (item.value !== this.value) {
                    this.$emit('change', item.value);
                }
            }
        }
    };
</script>
<style lang="scss" scoped>
    .status-chooser {
        display: flex;
        height: 100%;
        max-height: $height-button;
    }

    .selected-status {
        @include border;
        @include border-radius-small;
        user-select: none;
        padding: 0.25em 0.5em;
        height: 34px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;

        .name {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        .icon {
            margin-left: 0.25em;
        }

        &.disabled {
            background: $color-disabled-bg;
            color: $color-disabled-text;
            pointer-events: none;;
        }
    }
</style>